// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { hasPermission } from '../../auth/authUtils';
import permissionTypes from '../../../constants/permissionTypes';
import CompanyPopup from '../../popups/company';
import ImageFromApi from '../ImageFromApi';
import icons from '../../../constants/icons';
import { useAppSelector } from '../../../hooks';

export interface CompanyLinkProps {
  id: any;
  name?: any;
  fallbackText?: any;
  imageId?: any;
  imageSize?: any;
  hideImage?: any;
  colourHex?: any;
  onClick?: any;
}

function CompanyLink({
  id,
  name,
  fallbackText,
  imageId,
  imageSize,
  hideImage,
  colourHex,
  onClick,
}: CompanyLinkProps) {
  const companies = useAppSelector((state) => state.companies);
  const currentUser = useAppSelector((state) => state.auth);

  const [image, setImage] = useState(imageId);
  useEffect(() => {
    if (!imageId && companies) {
      setImage(companies.find((x) => x.id === id)?.imageId);
    }
  }, [imageId, companies, id]);

  const [colour, setColour] = useState(colourHex);
  useEffect(() => {
    if (!colourHex && companies) {
      setColour(companies.find((x) => x.id === id)?.colourHex);
    }
  }, [colourHex, companies, id]);

  const handleOnClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <div className="d-flex align-items-center">
      {!hideImage && (name || id) && (
        <ImageFromApi
          imageId={image}
          imageSize={imageSize}
          fallbackIcon={icons.COMPANY}
          colourHex={colour}
        ></ImageFromApi>
      )}
      {id && name ? (
        hasPermission(currentUser, permissionTypes.MANAGE_COMPANIES) ? (
          <CompanyPopup id={id}>
            <NavLink to={`/company/${id}`} onClick={handleOnClick}>
              {name}
            </NavLink>
          </CompanyPopup>
        ) : (
          name
        )
      ) : name ? (
        name
      ) : (
        fallbackText || '-'
      )}
    </div>
  );
}

export default CompanyLink;
